
	import { Vue, Component, Prop } from "vue-property-decorator";
	import SearchRequestForm from "./SearchRequestForm.vue";

	@Component({
		name: "search-form",
		components: {
			SearchRequestForm
		}
	})
	export default class SearchForm extends Vue {
		modal = false;

		@Prop({ default: 0 })
		mode!: number;

		@Prop({ default: "" })
		searchKeyword: string;

		@Prop({ default: "New search request" })
		formOpenerText: string;

		@Prop({ default: "Search request" })
		formTitle: string;

		@Prop({ default: "" })
		formHelp: string;

		@Prop({ default: "" })
		searchText: string;

		@Prop({ default: "Advanced search" })
		advancedSearchText: string;

		@Prop({ default: "Send" })
		okTitle: string;

		@Prop({ default: "Cancel" })
		cancelTitle: string;

		created() {
			console.log(`${this.$options.name} created`);
		}
		
		protected closeModal(): void {
			setTimeout(() => this.modal = false, 1000);
		}
	}
